import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  submitContact({ commit, state }, data) {
    return axios
      .post('/consumer-api/contact/v1/contact-us', data)
      .then((response) => {
        return true
      })
      .catch((error) => {
        return Promise.reject(error.response.data.message)
      })
  },

  submitAffiliate({ commit, state }, data) {
    return axios
      .post('/consumer-api/contact/v1/affiliate', data)
      .then((response) => {
        return true
      })
      .catch((error) => {
        return Promise.reject(error.response.data.message)
      })
  },
}
